import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";

/**
 * Per-rule skip toggles for direct purchase transactions.
 * When a rule is checked (true), its weighted risk contribution is zeroed for
 * direct purchase transactions. The raw rule score is still recorded.
 *
 * The set of rules is derived from weightConfig keys (minus "total") so it stays
 * in sync with the POS rule set. Existing config rows may have a null skip config
 * (only the threshold was seeded by the backend), so it is initialized here.
 */
const buildInitialState = (config, weightConfig) => {
  const ruleKeys = Object.keys(weightConfig || {}).filter(
    (key) => key !== "total",
  );
  const result = {};
  ruleKeys.forEach((key) => {
    result[key] = Boolean(config && config[key]);
  });
  return result;
};

const Component = ({ config, weightConfig, onChange }) => {
  const [data, updateData] = useImmer(() =>
    buildInitialState(config, weightConfig),
  );

  useEffect(() => {
    updateData(buildInitialState(config, weightConfig));
  }, [config, weightConfig]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const toggleRuleSkip = (ruleName) => {
    updateData((d) => {
      d[ruleName] = !d[ruleName];
    });
  };

  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Rule name</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(data).map((entry) => (
          <tr key={entry[0]} className={entry[1] ? "warn" : ""}>
            <td>{UtilService.camelCaseToReadable(entry[0])}</td>
            <td>
              <input
                type="checkbox"
                checked={entry[1]}
                onChange={() => toggleRuleSkip(entry[0])}
              />
              &nbsp;
              {entry[1] ? "Skipped" : "Evaluated"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Component;
